import { render, staticRenderFns } from "./EditProductView.vue?vue&type=template&id=5605f650&scoped=true&"
import script from "./EditProductView.vue?vue&type=script&lang=ts&"
export * from "./EditProductView.vue?vue&type=script&lang=ts&"
import style0 from "./EditProductView.vue?vue&type=style&index=0&id=5605f650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5605f650",
  null
  
)

export default component.exports